import React from 'react'

import { createValidIcon } from '@ui/icons/utils/type-helper'

export const ArrowCircleLeftRightIcon = createValidIcon((props) => {
  const { size, color } = props

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
    >
      <path
        d='M2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12ZM16.375 10.125C16.7202 10.125 17 9.84518 17 9.5C17 9.15482 16.7202 8.875 16.375 8.875L9.13388 8.875L9.94194 8.06694C10.186 7.82286 10.186 7.42714 9.94194 7.18306C9.69786 6.93898 9.30214 6.93898 9.05806 7.18306L7.18306 9.05806C6.93898 9.30214 6.93898 9.69786 7.18306 9.94194L9.05806 11.8169C9.30214 12.061 9.69786 12.061 9.94194 11.8169C10.186 11.5729 10.186 11.1771 9.94194 10.9331L9.13388 10.125H16.375ZM14.9419 16.8169L16.8169 14.9419C17.061 14.6979 17.061 14.3021 16.8169 14.0581L14.9419 12.1831C14.6979 11.939 14.3021 11.939 14.0581 12.1831C13.814 12.4271 13.814 12.8229 14.0581 13.0669L14.8661 13.875H7.625C7.27982 13.875 7 14.1548 7 14.5C7 14.8452 7.27982 15.125 7.625 15.125H14.8661L14.0581 15.9331C13.814 16.1771 13.814 16.5729 14.0581 16.8169C14.3021 17.061 14.6979 17.061 14.9419 16.8169Z'
        fill={color}
      />
    </svg>
  )
})
